import axiosInstance from "@/services/axiosInterceptor";

export async function getCommentsFromTaskId(id) {
  try {
    const response = await axiosInstance.get(`students/task/${id}/comments`);
    const rows = response?.data.rows;
    const users = response?.data.users;
    const formatedData = rows.map((x) => {
      return { ...x, userId: users[x.userId] };
    });
    return formatedData;
  } catch (error) {
    throw error;
  }
}
